import React from "react";
import ReactDOM from "react-dom";
import { Styles } from "./styled";

const Modal = ({ children, onClose, loading }) => {
  const handleClose = () => {
    if (!loading) onClose();
  };
  return (
    <Styles>
      <div className="bg" onClick={handleClose}></div>
      <div className="modal-container">
        {!loading && (
          <button className="btn btn-2" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
              <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
            </svg>
          </button>
        )}
        {children}
      </div>
    </Styles>
  );
};

function ModalPortal({ children, onClose }) {
  return ReactDOM.createPortal(
    <Modal onClose={onClose}>{children}</Modal>,
    document.getElementById("root")
  );
}

export default ModalPortal;
